<template src="./html/Login.html"></template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'
	import ChooseLanguage from './../../chooseLanguage/layout/ChooseLanguage.vue'

	export default {
		components: {
			'choose-language': ChooseLanguage,
		},
		watch: {
			'data.platform'() {
				this.data.platform = this.$options.filters.slugify(this.data.platform)
			},
		},
		data () {
			return {
				data: {
					username: '',
					password: '',
					client_id: process.env.CLIENT_ID,
					client_secret: process.env.CLIENT_SECRET,
					grant_type: process.env.GRANT_TYPE,
					platform: this.getAccountCookie(),
				},
				languages: null,
				activation: null,
				token: null,
				expiration_date: null,
			}
		},
		created() {
			this.$validator.extend('existsAccount', {
				getMessage: field => 'La cuenta no esxiste.',
				validate: (value, [testProp]) => {
					if(value) {
						var data = {
							subdomain: value
						}
						return this.$http.post(this.$env.ROOT + '/api/gfactory/accounts/validation/exists', data)
						.then(response => {
							return {
								valid: response.body.valid
							}
						}).catch(function(response) {
							console.log(response)
						})
					} else {
						return false
					}
				}
			});

			if(this.$platform) {
				if(this.$platform.slug) {
					this.data.platform = this.$platform.slug
				}
			}
			if(this.$route) {
				if(this.$route.params) {
					if(this.$route.params.activation) {
						this.activation = this.$route.params.activation
						this.activate()
					}
				}
				if(this.$route.query) {
					if(this.$route.query.token) {
						this.token = this.$route.query.token
					}
					if(this.$route.query.expiration_date) {
						var expires_in = parseInt(this.$route.query.expiration_date) * 1000
						var now = Date.now()
						var expiration = expires_in + now
						this.expiration_date = expiration
					}
					if(this.token && this.expiration_date) {
						this.$auth.setToken(this.token, this.expiration_date)
						this.checkPackages()
					}
				}
			}
		},
		computed: {
			hasPlatform() {
				if(this.$platform) {
					return true
				} else {
					return false
				}
			}
		},
		methods: {
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.login()
					}
					return result
				})
			},
			login () {
				var loading = Ladda.create(this.$refs.btnLogin)
				loading.start()

				this.$http.post(this.$env.ROOT + "/oauth/token", this.data)
				.then(response => {
					var expires_in = parseInt(response.body.expires_in) * 1000
					var now = Date.now()
					var expiration = expires_in + now
					this.$auth.setToken(response.body.access_token, expiration)
					this.$auth.setAccount(this.data.platform)
					this.checkPackages()
				}).catch(function(response) {
					console.log(response)
					loading.stop()
					if(response.status == 401) {
						swal({
							title: response.statusText,
							text: response.body.message,
							type: "warning",
						})
					} else {
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning",
						})
					}
				})
			},
			checkPackages() {
				var from = null
				if(this.$route.query) {
					if(this.$route.query.from) {
						from = this.$route.query.from
					}
				}

				if(from) {
					this.$router.push(from)
				} else {
					if(this.$platform) {
						if(this.$platform.setting) {
							var main_package_id = this.$platform.setting.main_package_id
							if(main_package_id) {
								if(this.$platform.hasPackage(main_package_id)) {
									if(main_package_id == 1) {
										this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/cms')
									}
									if(main_package_id == 2) {
										this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management')
									}
									if(main_package_id == 3) {
										this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects')
									}
								}
							}
						}
					}
				}
				location.reload()
			},
			activate() {
				if(this.activation) {
					var that = this
					swal({
						title: that.$t("messages.attention"),
						text: 'Activando...',
						onOpen: () => {
							swal.showLoading()
							that.$http.get('activation/' + this.activation)
							.then(response => {
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								console.log(response)
								if(response.status == 409) {
									swal({
										title: response.body.title,
										text: response.body.text,
										type: 'warning',
									})
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									})
								}
							})
						},
					})
				}
			},
			getAccountCookie() {
				var account = null
				var re = new RegExp("account=([^;]+)")
				var value = re.exec(document.cookie)
				account =  (value != null) ? unescape(value[1]) : null;
				return account
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/authentication/views/Login.vue